// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2UUxz","actionsCol":"EnrolledClinics_actionsCol__3deVs"};